{
  "titles": {
    "menuTitle": "Contact met DebitRoom",
    "faqMenuTitle": "Veelgestelde vragen",
    "pageTitle": "Contact met DebitRoom"
  },
  "fields": {
  }
}
